import { Injectable } from '@angular/core';
import { EncField, Encoding } from '@mode-vegas/vegas';
import { ChartTypes } from '@mode/shared/contract-common';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import * as ViewDataModalSelectors from './view-data-modal/view-data-modal.selectors';
import { closeModal, openModal, setOffset } from './view-data-modal/view-data-modal.actions';

// Only partially implemented facade due to the reducers and actions existing in the legacy world

@Injectable({
  providedIn: 'root',
})
export class ViewDataModalFacade {
  paging$: Observable<ChartTypes.ChartPaging>;
  isOpen$: Observable<boolean>;
  queryToken$: Observable<string>;
  encoding$: Observable<Encoding>;
  title$: Observable<string>;

  constructor(private store: Store) {
    this.paging$ = store.select(ViewDataModalSelectors.selectPaging);
    this.isOpen$ = store.select(ViewDataModalSelectors.selectIsOpen);
    this.queryToken$ = store.select(ViewDataModalSelectors.selectQueryToken);
    this.encoding$ = store.select(ViewDataModalSelectors.selectEncoding);
    this.title$ = store.select(ViewDataModalSelectors.selectTitle);
  }

  closeModal() {
    this.store.dispatch(closeModal());
  }

  openModal(encoding: Encoding, seriesDetail: EncField[] | undefined, queryToken: string, title: string) {
    this.store.dispatch(openModal({ encoding, seriesDetail, queryToken, title }));
  }

  setOffset(offset: number) {
    this.store.dispatch(setOffset({ offset }));
  }
}
